// react
import React, { useState } from "react";

// third-party
import { Helmet } from "react-helmet-async";

// application
import PageHeader from "../shared/PageHeader";
import { FormattedMessage } from "react-intl";
import { url } from "../../helper";
// data stubs
import theme from "../../data/theme";
import { useHistory } from "react-router-dom";
import AccountLogin from "./AccountLogin";

export default function AccountPageLogin() {
    const [input, Setinput] = useState({});
    const history = useHistory();

    const checkEmail = (email) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return "true";
        }
        // SetError( [...error,[{'pass':'not equal'}]])
        return "false";
    };

    const comfirmPss = () => {
        return false;
    };

    const register = (event) => {
        event.preventDefault();

        checkEmail();
        comfirmPss();

        let options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: input.email,
                password: input.password,
                password_confirmation: input.confirm_password,
            }),
        };

        fetch(url + "/api/customer/register", options)
            .then((responce) => responce.json())
            .then((res) => {
                if (res.message == "Your account has been created successfully.") {
                    history.push("/");
                } else {
                    if (res.email.length) {
                        alert(res.email[0]);
                    }

                    if (res.password.length) {
                        alert(res.password[0]);
                    }
                }
            })
            .catch((err) => console.error(err, "asdasdasd"));
    };
    const handleChange = (e) => {
        input[e.target.name] = e.target.value;
        Setinput(input);
    };
    const breadcrumb = [
        { title: <FormattedMessage id="home" defaultMessage="Գլխավոր էջ" />, url: "" },

        { title: <FormattedMessage id="login.account" defaultMessage="Login" />, url: "" },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Login — ${theme.name}`}</title>
            </Helmet>
            <PageHeader breadcrumb={breadcrumb} />
            <div className="block">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6 d-flex">
                            <div className="card flex-grow-1 mb-md-0">
                                <div className="card-body">
                                    <AccountLogin />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
